<template>
  <div id="app" style="background: #2c2d3a">
    <div class="row pb-3 px-5 pt-3" style="max-width: 100vw">
      <div class="col-sm-12 col-md-8 text-left"><img @click="routeToDash" class="img-fluid ml-4" src="../assets/Logo_Print-01.png" style="height:40px"></div>
      <div class="col-sm-6 col-md-2 mt-2">
        <span class="logoutFont text-right" @click="routeToDocuments" style="cursor: pointer;">Documentation</span>
      </div>
      <div class="col-sm-6 col-md-2 my-auto"><span class="logoutFont pr-4 mr-2"
                  @click="logout"
                  style="cursor: pointer;"><i class="fas pr-2 fa-sign-out-alt"></i>Logout</span></div>
    </div>
  </div>
</template>

<script>
import { AUTH_LOGOUT } from '../store/actions/auth'

export default {
  name: "Navbar",
  props: {
  },
  components: {
  },
  data() {
    return {
    };
  },
  watch: {
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    routeToDocuments() {
      this.$router.push('/under-Maintenance')
    },
    routeToDash() {
      this.$router.push('/under-Maintenance')
    },
    logout() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/login'))
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logoutFont {
  color: white;
  font-size: 1rem;
  font-weight: bolder;
}
</style>
